import React from "react";

export interface WaitlistState {
  // booked out offers can be chosen and end up on the waitlist
  enabled: boolean;
  // the zip code is outside the whitelist, so every offer ends up on the waitlist
  allToWaitlist: boolean;
  // message at the zip code field when only the waitlist is possible
  zipCodeMessage: string;
}

export const WaitlistContext = React.createContext<WaitlistState>({
  enabled: false,
  allToWaitlist: false,
  zipCodeMessage: ""
});
